import { useCallback, useEffect, useRef } from 'react';
import useFetchStateless, { muteAll } from 'hooks/useFetch';
import { useAppSelector, useAppStore } from 'store/hooks';
import { getAutoInvestActivity } from '../actions/autoinvest';
import { selectAutoinvestActivitiesInitialLoading, selectAutoInvestActivitySectionsForAccount, } from '../reducers/selectors';
const useAutoInvestActivities = (accountId) => {
    const store = useAppStore();
    const flashListData = useAppSelector((state) => selectAutoInvestActivitySectionsForAccount(state, accountId));
    const shouldLoadSecondPage = useRef(false);
    const [, , , fetch] = useFetchStateless(muteAll);
    const loading = useAppSelector((state) => accountId ? state.unpersistedInvestReducer.requestingAutoinvestActivitiesForTradingAccount?.[accountId] : false);
    const initialLoading = useAppSelector((state) => selectAutoinvestActivitiesInitialLoading(state, accountId));
    const loadMoreData = useCallback(() => {
        const token = accountId
            ? store.getState().unpersistedInvestReducer.requestingAutoinvestActivitiesPaginationTokenForTradingAccount?.[accountId]
            : undefined;
        if (token && accountId) {
            fetch(getAutoInvestActivity({
                accountId,
                paging: { token },
            }));
        }
    }, [accountId]);
    useEffect(() => {
        if (!loading && shouldLoadSecondPage.current) {
            shouldLoadSecondPage.current = false;
            loadMoreData();
        }
    }, [loadMoreData, loading]);
    const onLoadNextPage = useCallback(() => {
        if (loading) {
            shouldLoadSecondPage.current = true;
        }
        else {
            loadMoreData();
        }
    }, [loadMoreData, loading]);
    useEffect(() => {
        if (!initialLoading && accountId) {
            fetch(getAutoInvestActivity({ accountId, paging: { page: 1, perPage: 30 } }));
        }
        // Runs only once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [flashListData, onLoadNextPage, initialLoading];
};
export default useAutoInvestActivities;
